import { useMemo } from "react";
import { useAuthorizedUser } from "src/features/auth/useAuthorizedUser";
import { pagesPath } from "src/utils/$path";

export const useWorkspacePagesPath = () => {
  const { currentWorkspace } = useAuthorizedUser();
  return useMemo(
    () => pagesPath.w._workspaceId(currentWorkspace.id),
    [currentWorkspace.id],
  );
};
